import { render, staticRenderFns } from "./threeIndex.vue?vue&type=template&id=5dcaf56c&scoped=true&"
import script from "./threeIndex.vue?vue&type=script&lang=js&"
export * from "./threeIndex.vue?vue&type=script&lang=js&"
import style0 from "./threeIndex.vue?vue&type=style&index=0&id=5dcaf56c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcaf56c",
  null
  
)

export default component.exports